let hasReloadedForUpdate = false;

export const registerSW = async () => {
  if (!('serviceWorker' in navigator)) return;

  try {
    const registration = await navigator.serviceWorker.register('/sw.js', {
      scope: '/',
      updateViaCache: 'none',
    });

    registration.addEventListener('updatefound', () => {
      const worker = registration.installing;
      if (!worker) return;

      worker.addEventListener('statechange', () => {
        if (
          worker.state === 'installed' &&
          navigator.serviceWorker.controller
        ) {
          worker.postMessage({ type: 'SKIP_WAITING' });
        }
      });
    });

    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (hasReloadedForUpdate) return;
      hasReloadedForUpdate = true;
      window.location.reload();
    });

    await registration.update();
  } catch (error) {
    console.error('Service worker registration failed', error);
  }
};

export default defineNuxtPlugin(() => {
  if ('requestIdleCallback' in window) {
    requestIdleCallback(registerSW, { timeout: 5000 });
  } else {
    setTimeout(registerSW, 200);
  }
});
